export default "__VITE_ASSET__DbE$DNvG__"